if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Get the form element and initialize variables
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      // Submit handler for the Add to Cart button
      onSubmitHandler(evt) {
        evt.preventDefault(); // Prevent the form from submitting normally


        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }

        this.handleErrorMessage(); // Clear any existing error messages

        // Disable the submit button and show the loading spinner
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        // Create the config for the fetch request
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form); // Collect form data


        // If the cart drawer or notification exists, append the cart section data
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // Perform the fetch request to add the item to the cart
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {
              // Handle error scenario when the item is not available
              console.error("Cart error:", response.message); // Debugging
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;

              // Mark the item as sold out
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              updateCart();
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });

              // Update the cart UI after adding the item
              updateCartUI(response);
            }

            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error("Error adding to cart:", e); // Debugging
          })
          .finally(() => {
            // Reset the loading state
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      // Handle displaying error messages
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Toggle the submit button between enabled and disabled
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          this.submitButtonText.innerHTML =
            '<i class="fa fa-plus-circle"></i><p class="a2c">Add to cart</p>';
        } else {
          this.submitButton.removeAttribute("disabled");

          // Instead of setting text, insert the cart icon
          this.submitButtonText.innerHTML =
            '<i class="fa fa-plus-circle"></i><p class="a2c">Add to cart</p>';
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

// Fetch the cart and update the UI
function updateCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      updateCartUI(cart);
      // if (window.innerWidth <= 768) {
      //   window.location.href = '/cart';
      // }
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

// Update the cart icon with the correct item count
function updateCartUI(cart) {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  let cartCountBubble = document.querySelector(".cart-count-bubble");

  // Create cart bubble if it doesn't exist and there are items in the cart
  if (!cartCountBubble && cart.item_count > 0) {
    cartCountBubble = document.createElement("div");
    cartCountBubble.className = "cart-count-bubble flex";

    const countSpan = document.createElement("span");
    countSpan.setAttribute("aria-hidden", "true");
    countSpan.innerText = cart.item_count;

    const visuallyHiddenSpan = document.createElement("span");
    visuallyHiddenSpan.className = "visually-hidden";
    visuallyHiddenSpan.innerText = `${cart.item_count} items`;

    cartCountBubble.appendChild(countSpan);
    cartCountBubble.appendChild(visuallyHiddenSpan);

    cartIcon.appendChild(cartCountBubble);
  }

  // Update the cart count bubble with the new item count
  if (cartCountBubble) {
    cartCountBubble.querySelector('span[aria-hidden="true"]').innerText =
      cart.item_count;
    cartCountBubble.querySelector(
      ".visually-hidden"
    ).innerText = `${cart.item_count} items`;
    // Trigger celebration animation
    // createConfetti(cartIcon);
  }
  // Function to create confetti particles

}
